import React from 'react';
import { useSpeechSynthesis } from 'react-speech-kit';

const ImageDisplay = ({ items }) => {
  const { speak, cancel, voices } = useSpeechSynthesis();

  const handleMouseEnter = (item) => {
    speak({ text: item.word, voice: voices[0] });
  };

  const handleMouseLeave = () => {
    cancel();
  };

  return (
    <div className="image-display">
      {items.map((item, index) => (
        <div
          key={index}
          className="image-item"
          onMouseEnter={() => handleMouseEnter(item)}
          onMouseLeave={handleMouseLeave}
        >
          <img src={item.src} alt={item.word} />
          <span>{item.word}</span>
        </div>
      ))}
    </div>
  );
};

export default ImageDisplay;